import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, SelectItem } from 'primeng';
import { Moderation } from 'src/app/classes/moderation';
import { EncryptionService } from 'src/app/services/encryption.service';
import { ModerationService } from 'src/app/services/moderation.service';
import { UtilisateursService } from 'src/app/services/utilisateurs.service';

@Component({
  selector: 'app-affectation',
  templateUrl: './affectation.component.html',
  styleUrls: ['./affectation.component.css']
})
export class AffectationComponent implements OnInit {

  constructor(public ref: DynamicDialogRef, public conf: DynamicDialogConfig, private utilisateurService:UtilisateursService, private moderationService:ModerationService,private encryptService:EncryptionService) { }
  
  moderation:Moderation;
  listeOp : SelectItem[] = [];
  selectedOp : number;
  utilisateur: any;

  ngOnInit(): void {
    this.utilisateur = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    this.moderation = this.conf.data.moderation;
    this.utilisateurService.getListeOp().subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        let liste = value['data'];

        liste.forEach(current => {
          console.log(current)
          let currentOp = {
            label: current,
            value: current
          };

          this.listeOp.push(currentOp);
        });
        console.log(this.listeOp);
      }
    });
  }


  affecterFiche() {
    //let matricule = parseInt(this.utilisateur.matricule);
    
    this.moderationService.affecterFiche(this.selectedOp, this.moderation.idModeration).subscribe( value => {
      if(value["status"] !== "success") {
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        alert('Affectation effectuée');

        this.ref.destroy();
      }
    });
  }
}
